import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getCasesTypeByTenantId = createWrappedAsyncThunk(
  "cases/getCasesTypeByTenantId",
  async ({ tenant_id }) => {
    const { data } = await httpClient.get(`cases`, {
      params: {
        tenant_id,
      },
    });
    return { tenant_id, data };
  },
);
